import { LegalPage } from "./LegalPage";
import { TERMS_DOC } from "./legalDocs";

/** Términos de uso (docs/legal/terminos.md): público, con el candado de marcadores {{ }}. */
export const TermsPage = () => <LegalPage doc={TERMS_DOC} />;

TermsPage.path = TERMS_DOC.path;
